import React from 'react'
import clsx from 'clsx'

import Heading from '../../components/Heading/Heading'
import Button from '../../components/Button/Button'

import bgImageDesktop from '../../images/cta-desktop.jpg'
import bgImageMobile from '../../images/Cta-mobile.jpg'

import './cta.scss'

export const Cta = ({ otherClasses, toggleFunc }) => {
  const ctaClasses = clsx(otherClasses, 'w-full relative py-10 lg:py-[120px]')

  return (
    <section className={ctaClasses} data-testid="cta">
      <img
        src={bgImageDesktop}
        alt="background-desktop"
        className="absolute top-0 left-0 bottom-0 w-full h-full -z-10 hidden lg:block"
      />
      <img
        src={bgImageMobile}
        alt="background-desktop"
        className="absolute top-0 left-0 bottom-0 w-full h-full -z-10 lg:hidden"
      />
      <div className="w-full max-w-[1512px] mx-auto flex flex-col lg:flex-row items-start gap-8 lg:gap-0 lg:items-center lg:justify-between px-6 lg:px-20 xl:px-[136px]">
        <div className="mr-6">
          <Heading
            type="h2"
            otherClasses="font-Manrope font-light text-[38px] leading-[52px] lg:text-[42px] lg:leading-[57px] text-white mb-4"
          >
            Because you deserve better.
          </Heading>
          <p className="font-Work_Sans text-sm leading-4 lg:text-base lg:leading-6 font-normal text-gray-200">
            Don’t stand for fraud – book a free consultation with our attorneys
            today.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
          <Button
            variant="primary"
            label="Free Consultation"
            otherClasses="whitespace-nowrap"
            onClick={() => toggleFunc('Contact Us')}
          />

          <a
            href="tel:6194361826"
            className="!border-[1px] !border-accent_orange_600 !rounded-full !py-3 !px-8 whitespace-nowrap bg-transparent text-base font-Work_Sans leading-6 p-[6px] font-semibold text-white hover:text-accent_orange_600 active:text-white button_text_link"
          >
            619-436-1826
          </a>
        </div>
      </div>
    </section>
  )
}

export default Cta
